import { map, Observable } from 'rxjs';

/**
 * Наименования ошибок валидации
 */
export enum ValidationErrorKeys {
  DELIVERY_ADDRESS_REQUIRED = 'DELIVERY_ADDRESS_REQUIRED',
  PICKUP_ADDRESS_REQUIRED = 'PICKUP_ADDRESS_REQUIRED',
  SERVICE_REQUIRED = 'SERVICE_REQUIRED',
  FLOOR_NOT_SPECIFIED = 'FLOOR_NOT_SPECIFIED',
  TIME_SLOT_REQUIRED = 'TIME_SLOT_REQUIRED',
  PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
  CONTACTS_REQUIRED = 'CONTACTS_REQUIRED',
  DELIVERY_CITY_MISMATCH_WITH_CURRENT_CITY = 'DELIVERY_CITY_MISMATCH_WITH_CURRENT_CITY',
}

export type ValidationErrorKey = keyof typeof ValidationErrorKeys;

/**
 * Объект с ошибками валидации
 */
export type ValidationErrors = {
  [key in ValidationErrorKey]?: string;
};

/**
 * Абстрактный класс для сервисов чекаута, которые участвуют в валидации
 */
export abstract class CheckoutValidator {
  abstract getValidationErrors(): Observable<ValidationErrors>;

  isValid(): Observable<boolean> {
    return this.getValidationErrors().pipe(map((errors) => Object.keys(errors).length === 0));
  }
}
